export default ["account", "personal", "profile"];
